import Swiper from 'swiper';

const defaultOptions = {
    navigation: {
        prevEl: '.js-slider-arrows-previous',
        nextEl: '.js-slider-arrows-next',
        disabledClass: 'slider-arrows__arrow--disabled',
    },
    slidesPerView: 1,
};

/**
 * Slider
 */
export default class Slider {
    constructor(element, options = defaultOptions) {
        if (!element) return;

        this.swiper = new Swiper(element, {...options});
    }
}
